"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lte = void 0;
const lte = ({ leftValue, rightValue, }) => {
    if (leftValue === null || leftValue === undefined) {
        return { error: null, result: false };
    }
    if (rightValue === null || rightValue === undefined) {
        return { error: null, result: false };
    }
    if (Array.isArray(leftValue) || Array.isArray(rightValue)) {
        return {
            error: `Invalid comparison for less than or equal to: array provided as value`,
        };
    }
    const result = leftValue <= rightValue;
    return { error: null, result };
};
exports.lte = lte;
//# sourceMappingURL=lte.js.map